module.exports = __webpack_public_path__ + "img/Skirt-Front-B5-Da-Fb-Ge-Hc-Id-Ja.880deb9e.png";